// extracted by mini-css-extract-plugin
export default {"keen-slider":"imyYPatcl8xR8hYt0HkP","keen-slider__slide":"BwsBkesPAmbXX3tYt_mg"};
    if(module.hot) {
      // 1738844606868
      var cssReload = require("!../css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  